import { render, staticRenderFns } from "./UpdateOwnershipModal.vue?vue&type=template&id=138eba32&scoped=true&"
import script from "./UpdateOwnershipModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateOwnershipModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateOwnershipModal.vue?vue&type=style&index=0&id=138eba32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138eba32",
  null
  
)

export default component.exports